/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './components.css';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <div>
      <div className='header'>
        <h1 className='oswald'>akul srivastava</h1>
        <div className='menuDiv mt-2'>
          <Link to='/'>home</Link> &nbsp;
          <Link to='/blogs'>blogs</Link> &nbsp;
          <Link to='/about'>about</Link> &nbsp;
          <Link to='/contact'>contact</Link>
        </div>
      </div>
      <hr className='m-0' />
    </div>
  );
}
